import { withCompInfo } from '@wix/editor-elements-integrations'
import { DEFAULT_DURATIONS_MS } from '@wix/thunderbolt-commons'
import type { PageGroupCssVars } from '@wix/thunderbolt-components-native'

// @ts-ignore - Remove once pageTransition is added to the compInfo
export const css = withCompInfo<PageGroupCssVars, any>()(['pageTransition'], ({ pageTransition }) => {
	// @ts-ignore - Remove once pageTransition is added to the compInfo
	const transitionDuration = DEFAULT_DURATIONS_MS[pageTransition] || 0

	return {
		'--transition-duration': `${transitionDuration}ms`,
	}
})
